import { render } from "./management.cattle.io.user.vue?vue&type=template&id=0315b194"
import script from "./management.cattle.io.user.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.user.vue?vue&type=script&lang=js"

import "./management.cattle.io.user.vue?vue&type=style&index=0&id=0315b194&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__